/**
 * Created by mnaughton on 11/4/2015.
 */

/**
 * Router which shows the map-related pages.
 * @module app/routers/Map
 */
import RouterBase from "app/routers/RouterBase";
import LayoutCollection from "app/models/LayoutCollection";
import Layout from "app/models/Layout";
import MapService from "app/models/MapService";
import MapIndex from "app/views/map/MapIndex";
import $ from "jquery";
import _ from "underscore";
import mapContext from "app/views/map/MapContext";
import ErrorUtils from "app/utils/ErrorUtils";
import session from "app/Session";
import esriShim from "app/esri-shim";
import messenger from "app/Messenger";
import app from "app/App";
export default RouterBase.extend({
  root: "/map",

  routes: {
    map: "index",
    "map/service/:id": "service",
    "map/layout/:id": "layout",
  },

  load: function () {
    var esriLoad = new $.Deferred();
    var layoutLoad = new $.Deferred();

    esriShim.init(function (err) {
      if (err) {
        return esriLoad.reject(err);
      }

      esriLoad.resolve();
    });

    /*
		if (this._plugins) {
			pluginLoad = $.when();
		} else {
			pluginLoad = new $.Deferred();

			var mapPlugins = _.filter(this.options.context.app.plugins, function (plugin) {
				return !!plugin.map;
			});

			async.map(mapPlugins, function (plugin, cb) {
				plugin.map(function (err, instance) {
					if (err) {
						return cb(err);
					}

					cb(null, new MapPlugin(instance, plugin.plugin.mapText()));
				});
			}, function (err, results) {
				if (err) {
					return pluginLoad.reject(err);
				}

				self._plugins = results;
				pluginLoad.resolve(results);
			});
		}*/

    this.collection = new LayoutCollection([]);
    this.collection.fetch({
      success: _.bind(layoutLoad.resolve, layoutLoad),
      error: _.partial(function (deferred, collection, xhrError) {
        deferred.reject(xhrError);
      }, layoutLoad),
    });

    return $.when(layoutLoad, esriLoad);
  },

  index: function () {
    this._showLayout(
      Layout.CreateDefault({
        name: Layout.DefaultName(session),
      })
    );
  },

  service: function (id) {
    this.loading();

    var service = new MapService({
      id: id,
    });
    var self = this;

    service.fetch({
      success: function () {
        self.doneLoading();

        self._showLayout(Layout.CreateDefault(service));
      },
      error: ErrorUtils.apiHandler({
        activity: "displaying the service",
        cleanUp: function () {
          self.doneLoading();
        },
      }),
    });
  },

  layout: function (id) {
    var self = this;
    var layout = this.collection.get(id);

    if (layout) {
      layout.fetch({
        success: function () {
          self._showLayout(layout);
        },
        error: ErrorUtils.apiHandler({
          activity: "displaying the layout",
          skipUser: true,
          cleanUp: function () {
            messenger.warning(
              "A problem occurred refreshing the layout. An older version is loading."
            );
            self._showLayout(layout);
          },
        }),
      });
    } else {
      this.loading();
      this.reload()
        .done(function () {
          self.doneLoading();

          layout = self.collection.get(id);
          self._showLayout(layout);
        })
        .fail(
          ErrorUtils.errorHandler({
            activity: "displaying the layout",
            cleanUp: function () {
              self.doneLoading();
            },
          })
        );
    }
  },

  _showLayout: function (layout) {
    mapContext.operations.off();
    mapContext.setConfiguration(layout);

    var view = new MapIndex();

    view.render();

    app.pushView(view);
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/app/routers/Map.js
// module id = 941
// module chunks = 1